<div
  class="horizontal-nav-list-wrapper"
  [class.ia-nav]="isIaNavEnabled$ | async"
  horizontalNav
>
  <button type="button" class="previous-action action" #prevBtn>
    <div class="action-contents">
      <app-icon class="previous-icon action-icon" [icon]="chevronIcon">
      </app-icon>
    </div>
  </button>

  <ul class="horizontal-nav-list" #horizontalNavList>
    <li
      *ngFor="let navItem of navItems"
      class="horizontal-nav-item"
      #horizontalNavItem
    >
      <i2g-router-link
        [label]="navItem.label | translate"
        [route]="navItem.route"
        [navigationExtras]="navItem.navigationExtras"
        [trackingObject]="navItem.trackingObject"
        [trackingAction]="navItem.trackingAction"
        alignment="center"
        (linkClick)="onRoute.emit()"
      >
      </i2g-router-link>
    </li>
  </ul>

  <button type="button" class="next-action action" #nextBtn>
    <div class="action-contents">
      <app-icon class="next-icon action-icon" [icon]="chevronIcon"> </app-icon>
    </div>
  </button>
</div>
